import getMessage from 'src/background/utils/i18n.utils';
import { AccountAuthoritiesListItemComponent } from '@popup/steem/pages/app-container/settings/accounts/manage-account-authorities/account-authorities-list/account-authorities-list-item/account-authorities-list-item.component';
import React from 'react';
import { connect } from 'react-redux';
const AccountAuthoritiesList = ({ activeAccount }) => {
    return (React.createElement("div", { className: "account-authorities-list" },
        React.createElement("div", { className: "authorities-panel" },
            React.createElement(AccountAuthoritiesListItemComponent, { role: 'active', authority: activeAccount.account.active }),
            React.createElement(AccountAuthoritiesListItemComponent, { role: 'posting', authority: activeAccount.account.posting }),
            activeAccount.account.active.account_auths.length === 0 &&
                activeAccount.account.posting.account_auths.length === 0 && (React.createElement("div", { className: "no-authorities-found" }, getMessage('popup_html_manage_no_accounts_authorities'))))));
};
const mapStateToProps = (state) => {
    return {
        activeAccount: state.steem.activeAccount,
    };
};
const connector = connect(mapStateToProps, {});
export const AccountAuthoritiesListComponent = connector(AccountAuthoritiesList);
